import { Action, createReducer, on } from '@ngrx/store';
import { commonPatientActions } from './patient.action';
import { CommonPatientState, commonPatientIS } from './patient.state';

const commonPatientRegister = createReducer(
  commonPatientIS,
  on(commonPatientActions.setResultAction, (state, result) => ({
    ...state,
    result,
  })),

  on(commonPatientActions.addResultAction, (state, doctor) => ({
    ...state,
    result: {
      ...state.result,
      content: [doctor, ...state.result.content],
      numberOfElements: state.result.numberOfElements + 1,
      totalElements: state.result.totalElements + 1,
    },
  })),

  on(commonPatientActions.patchResultAction, (state, doctor) => ({
    ...state,
    result: {
      ...state.result,
      content: state.result.content.map((item) => {
        if (item.id === doctor.id) {
          return doctor;
        }
        return item;
      }),
    },
  })),

  on(commonPatientActions.setPatientAction, (state, data) => ({
    ...state,
    data,
  })),

  on(commonPatientActions.setResidenceAction, (state, residence) => ({
    ...state,
    residence,
  })),

  on(commonPatientActions.setPatientDefaultAction, (state) => ({
    ...state,
    data: commonPatientIS.data,
    residence: commonPatientIS.residence,
  })),

  on(commonPatientActions.setAllDefaultAction, () => commonPatientIS)
);

export function commonPatientReducer(
  state: CommonPatientState,
  action: Action
): any {
  return commonPatientRegister(state, action);
}
